export enum FillType {
  Filled = "filled",
  Half = "half",
  Empty = "empty"
}

export interface Data {}
export interface Props {
  size: number;
  fill: FillType | undefined;
}
export interface Computed {
  fillName: "Star-Filled" | "Star-Half" | "Star-Empty";
  sizeStyle: {
    width: string;
    height: string;
  };
}
export interface Methods {}
